import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import SummerCamp from '../../components/camps/summer/summer';
import WinterCamp from '../../components/camps/winter/winter';
import FootballCamp from '../../components/camps/football/football';
import { sixYardAxios } from '../../sixYardAxios';
import CampRegistrationForm from '../../components/camps/campRegistrationForm/campRegistrationForm';
import LoginModal from '../../components/containers/loginModal/loginModal';

const Camps = (props) => {
    const { slug } = useParams();
    const location = useLocation();
    const { state } = location;
    const [summerCamp, setSummerCamp] = useState([]);
    const [winterCamp, setWinterCamp] = useState([]);
    const [footballCamp, setFootballCamp] = useState([]);
    const [showCampRegistrationForm, setShowCampRegistrationForm] = useState(false);
    const [showLoginForm, setShowLoginForm] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState({});
    useEffect(() => {
        slug === 'summer-camp' && fetchCamp("summer", setSummerCamp);
        slug === 'winter-camp' && fetchCamp("winter", setWinterCamp);
        slug === 'football-camp' && fetchCamp("football", setFootballCamp);
    }, [slug]);
    useEffect(() => {
        props.isAuthenticated && setShowLoginForm(false);
    }, [props.isAuthenticated])
    useEffect(() => {
        if (state?.showCampRegistrationForm) {
            // Perform the actions based on the passed state
            props.setShowCampRegistrationForm(true);
            props.setCamp(state.camp);
            props.setBookNowAndChatBoxClicked(false);

            if (state.scrollToTop) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    }, [state]);
    const fetchCamp = async (camp, setCamp) => {
        try {
            const res = await sixYardAxios.get("/camps/" + camp);
            setCamp(res.data.data);
        } catch (error) { }
    };
    return (
        !showCampRegistrationForm ? <div>
            {slug === 'summer-camp' && <SummerCamp summerCamp={summerCamp}
                setShowCampRegistrationForm={setShowCampRegistrationForm} setSelectedPlan={setSelectedPlan} 
                isAuthenticated={props.isAuthenticated} setShowLoginForm={setShowLoginForm}/>}
            {slug === 'winter-camp' && <WinterCamp winterCamp={winterCamp}
                setShowCampRegistrationForm={setShowCampRegistrationForm} setSelectedPlan={setSelectedPlan} 
                isAuthenticated={props.isAuthenticated} setShowLoginForm={setShowLoginForm}/>}
            {slug === 'football-camp' && <FootballCamp footballCamp={footballCamp}
                setShowCampRegistrationForm={setShowCampRegistrationForm} setSelectedPlan={setSelectedPlan} 
                isAuthenticated={props.isAuthenticated} setShowLoginForm={setShowLoginForm}/>}
            {showLoginForm && <LoginModal setShowLoginForm={setShowLoginForm} currentPath={'/camps/' + slug} />}
        </div> : <CampRegistrationForm setShowCampRegistrationForm={setShowCampRegistrationForm}
            selectedPlan={selectedPlan} camp={slug === 'summer-camp' ? "Summer" : slug === 'winter-camp' ? "Winter" :
                slug === 'football-camp' && "Football"} />
    )
}
const mapStateToProps = state => ({
    isAuthenticated: state.auth.token !== null,
});
export default connect(mapStateToProps)(Camps);